import OffreValidationDevis from './offre.validation.devis.controller';

export default {
    controller: OffreValidationDevis,
    template: require('./offre.validation.devis.html')
};
